import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        Made with ❤ by Vikas | <a href="#" target="_blank">Github</a>
    </div>
  )
}

export default Footer
